import React from "react";
import { useTranslation } from "react-i18next";
import "../assets/css/material-kit.css"; // Import necessary CSS files
import "../assets/css/styles.css";
import backgroundGif from "../assets/img/smooth_image_transition_optimized.gif";
import mlSolutionsImg from "../assets/img/about_us/ml_solutions.png";
import aiPoweredAppsImg from "../assets/img/about_us/ai_powered_apps.png";
import computerVisionImg from "../assets/img/about_us/computer_vision.png";
import nlpLLMImg from "../assets/img/about_us/nlp_llm.png";
import { Link } from "react-router-dom";

const AboutUs = () => {
  const { t } = useTranslation();
  
  return (
    <div className="about-us bg-gray-200">

      {/* Header Section */}
      <header className="bg-gradient-dark">
        <div
          className="page-header min-vh-75"
          style={{
            backgroundImage: `url(${backgroundGif})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <span className="mask bg-gradient-dark opacity-6"></span>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center mx-auto my-auto">
                <h1 id="aboutus-title" className="text-white">
                  {t('aboutus.title')}
                </h1>
                <p id="aboutus-description" className="lead mb-4 text-white opacity-8">
                  {t('aboutus.description')}                  
                </p>
                <Link id="aboutus-create-account" to="/contact-us" className="btn bg-white text-dark">
                  {t('aboutus.create_account')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <div className="card card-body shadow-xl mx-3 mx-md-4 mt-n6">
        <section className="py-7">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="row justify-content-start">
                  {/* Expertise */}
                  <div className="col-md-6">
                    <div className="info">
                      <i className="material-icons text-3xl text-gradient text-info mb-3">
                        public
                      </i>
                      <h5 id="aboutus-expertise-title">{t('aboutus.sections.expertise.title')}</h5>
                      <p id="aboutus-expertise-description">
                        {t('aboutus.sections.expertise.description')}
                      </p>
                    </div>
                  </div>

                  {/* Innovation */}
                  <div className="col-md-6">
                    <div className="info">
                      <i className="material-icons text-3xl text-gradient text-info mb-3">
                        payments
                      </i>
                      <h5 id="aboutus-innovation-title">{t('aboutus.sections.innovation.title')}</h5>
                      <p id="aboutus-innovation-description">
                        {t('aboutus.sections.innovation.description')}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="row justify-content-start mt-4">
                  {/* Customized Solutions */}
                  <div className="col-md-6">
                    <div className="info">
                      <i className="material-icons text-3xl text-gradient text-info mb-3">
                        apps
                      </i>
                      <h5 id="aboutus-custom-title">{t('aboutus.sections.customized_solutions.title')}</h5>
                      <p id="aboutus-custom-description">
                        {t('aboutus.sections.customized_solutions.description')}
                      </p>
                    </div>
                  </div>

                  {/* Reliability */}
                  <div className="col-md-6">
                    <div className="info">
                      <i className="material-icons text-3xl text-gradient text-info mb-3">
                        3p
                      </i>
                      <h5 id="aboutus-reliability-title">{t('aboutus.sections.reliability.title')}</h5>
                      <p id="aboutus-reliability-description">
                        {t('aboutus.sections.reliability.description')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Our Technological Ingredients Section */}
      <section className="pb-5 position-relative bg-gradient-dark mx-n3">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-start mb-5 mt-5">
              <h3 id="technology-title" className="text-white z-index-1 position-relative">
                {t('technology.title')}
              </h3>
              <p id="technology-description" className="text-white opacity-8 mb-0">
                {t('technology.description')}
              </p>
            </div>
          </div>

          <div className="row">
            {/* Technology Card 1 */}
            <div className="col-lg-6 col-12">
              <div className="card card-profile mt-4">
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-12 mt-n5">
                    <div className="p-3 pe-md-0">
                      <img
                        className="w-100 border-radius-md shadow-lg pop-up-effect"
                        src={mlSolutionsImg}
                        alt="Machine Learning Solutions"
                      />
                    </div>
                  </div>
                  <div className="col-lg-8 col-md-6 col-12 my-auto" style={{ height: "200px", overflow: "auto" }}>
                    <div className="card-body ps-lg-0">
                      <h5 id="technology-ml-title" className="mb-0">{t('technology.sections.ml.title')}</h5>
                      <p id="technology-ml-description" className="mb-0">
                        {t('technology.sections.ml.description')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Technology Card 2 */}
            <div className="col-lg-6 col-12">
              <div className="card card-profile mt-4">
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-12 mt-n5">
                    <div className="p-3 pe-md-0">
                      <img
                        className="w-100 border-radius-md shadow-lg pop-up-effect"
                        src={aiPoweredAppsImg}
                        alt="AI Powered Apps"
                      />
                    </div>
                  </div>
                  <div className="col-lg-8 col-md-6 col-12 my-auto" style={{ height: "200px", overflow: "auto" }}>
                    <div className="card-body ps-lg-0">
                      <h5 id="technology-ai-title" className="mb-0">{t('technology.sections.ai_apps.title')}</h5>
                      <p id="technology-ai-description" className="mb-0">
                        {t('technology.sections.ai_apps.description')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-4">
            {/* Technology Card 3 */}
            <div className="col-lg-6 col-12">
              <div className="card card-profile mt-4 z-index-2">
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-12 mt-n5">
                    <div className="p-3 pe-md-0">
                      <img
                        className="w-100 border-radius-md shadow-lg pop-up-effect"
                        src={computerVisionImg}
                        alt="Computer Vision Expertise"
                      />
                    </div>
                  </div>
                  <div className="col-lg-8 col-md-6 col-12 my-auto" style={{ height: "200px", overflow: "auto" }}>
                    <div className="card-body ps-lg-0">
                      <h5 id="technology-cv-title" className="mb-0">{t('technology.sections.cv.title')}</h5>
                      <p id="technology-cv-description" className="mb-0">
                        {t('technology.sections.cv.description')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Technology Card 4 */}
            <div className="col-lg-6 col-12">
              <div className="card card-profile mt-4 z-index-2">
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-12 mt-n5">
                    <div className="p-3 pe-md-0">
                      <img
                        className="w-100 border-radius-md shadow-lg pop-up-effect"
                        src={nlpLLMImg}
                        alt="NLP & Large Language Models"
                      />
                    </div>
                  </div>
                  <div className="col-lg-8 col-md-6 col-12 my-auto" style={{ height: "200px", overflow: "auto" }}>
                    <div className="card-body ps-lg-0">
                      <h5 id="technology-nlp-title" className="mb-0">{t('technology.sections.nlp.title')}</h5>
                      <p id="technology-nlp-description" className="mb-0">
                        {t('technology.sections.nlp.description')}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Success Stories Section */}
      <section id="success-stories" className="py-5">
        <div className="container text-center">
          <h2 id="success-title">{t('success.title')}</h2>
          <div className="row mt-4">
            {/* Story 1 */}
            <div className="col-md-4">
              <h5 id="success-story1-title">{t('success.story1.title')}</h5>
              <p id="success-story1-description">
                {t('success.story1.description')}
              </p>
            </div>
            {/* Story 2 */}
            <div className="col-md-4">
              <h5 id="success-story2-title">{t('success.story2.title')}</h5>
              <p id="success-story2-description">
                {t('success.story2.description')}
              </p>
            </div>
            {/* Story 3 */}
            <div className="col-md-4">
              <h5 id="success-story3-title">{t('success.story3.title')}</h5>
              <p id="success-story3-description">
                {t('success.story3.title')}
              </p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default AboutUs;
